
import { fetchGasSearchResultList, fetchBizoppSugList } from '@/pages-v2/Gas/SearchStoreGas/components/SearchBar/service'
import { getGeo } from '@/pages-v2/home/storeList/component/StoreFilter/components/StoreCityFilter/utils'
export default {
  async getBizoppSugList ({ commit, state }, params = {}) {
    const geo = await getGeo()
    params.lat = geo.lat
    params.lng = geo.lng
    const res = await fetchBizoppSugList(params)
    if (res.data !== undefined && res.data.hasOwnProperty('list')) {
      commit('updateSugNameResultData', res.data.list)
      commit('updateSugLoading', false)
    }
  },
  async getStoreResultList({ commit, state }, params = {}) {
    let type = ''
    switch (state.resultSugType) {
      case 'all':
        type = 1
        break
      case 'area':
        type = 4
        break
      case 'my':
        type = 2
        break
    }
    const geo = await getGeo(params.reset)
    const handleParams = {}
    handleParams.lat = geo.lat
    handleParams.lng = geo.lng
    if (params.reset) {
      handleParams.pageNo = 1
    } else {
      handleParams.pageNo = state.pageNo
    }
    handleParams.bizCityId = params.cityId
    handleParams.pageSize = 20
    handleParams.requestType = type
    handleParams[state.sugTypeValue] = state.sugKeyword.keyword
    commit('updateResultLoading', true)
    const res = await fetchGasSearchResultList(handleParams)
    if (res.data !== undefined) {
      commit('updateSugResultList', {
        reset: params.reset,
        ...res.data
      })
      commit('updateResultLoading', false)
    }
  },
  async getRepeatBusinessList({ commit, state }, params = {}) {
    const handleParams = {
      requestType: 1,
      requestSource: 1,
    }
    handleParams.lat = state.visitInitInfo.shopLat
    handleParams.lng = state.visitInitInfo.shopLng
    if (params.reset) {
      handleParams.pageNo = 1
    } else {
      handleParams.pageNo = state.repeatBusinessPageNo
    }
    handleParams.bizCityId = state.visitInitInfo.shopCityID
    handleParams.pageSize = 20
    handleParams.notInShopId = params.shopId
    handleParams.shopName = params.keyword
    handleParams.distance = state.distance
    commit('updateRepeatBusinessLoading', true)
    const res = await fetchGasSearchResultList(handleParams)
    if (res.data !== undefined) {
      commit('updateRepeatBusinessSugList', {
        reset: params.reset,
        ...res.data
      })
      commit('updateRepeatBusinessLoading', false)
    }
  }
}
